import { configApi } from '../http-client.js'

export const getConfigKeys = () => {
	return configApi.get('/api/ConfigKeys')
}
